



























































































































































































































import {Component, Mixins, Watch} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {$, success} from 'simpli-web-sdk'
import moment from 'moment'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {Period} from '@/enums/Period'
import {ChartType} from '@/enums/ChartType'
import CockpitRequest from '@/model/request/CockpitRequest'
import CockpitResponse from '@/model/response/CockpitResponse'
import FilterCockpit from '@/components/filters/FilterCockpit.vue'
import Chart from '@/components/Chart.vue'
import Responsavel from '@/model/resource/Responsavel'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import {DeliveryEvent} from '@/enums/DeliveryEvent'
import {PerformanceState} from '@/enums/PerformanceState'
import MotoristaCollection from '@/model/collection/MotoristaCollection'
import PosicaoMotorista from '@/model/resource/PosicaoMotorista'
import DriverPerformance from '@/components/DriverPerformance.vue'
import FilterToggle from '@/components/FilterToggle.vue'
import PerformanceData from '@/components/PerformanceData.vue'
import Performance from '@/components/Performance.vue'
import * as Helper from '@/helpers'
import CockpitPerformancePorDataResponse from '@/model/response/CockpitPerformancePorDataResponse'
import CockpitPerformanceResponse from '@/model/response/CockpitPerformanceResponse'

const metaInfo = () => ({
  title: $.t('view.cockpit.title'),
})

@Component({
  metaInfo,
  components: {Performance, PerformanceData, DriverPerformance, FilterCockpit, Chart, FilterToggle},
})
export default class CockpitView extends Mixins(MixinFilter) {
  @Action('auth/auth') auth!: Function
  @Action('sentinel/onUpdate') onUpdate!: Function

  @Getter('auth/responsavel') user!: Responsavel

  Period = Period
  ChartType = ChartType
  DeliveryStatus = DeliveryStatus
  DeliveryEvent = DeliveryEvent
  PerformanceState = PerformanceState
  Helper = Helper

  filter = new CockpitRequest()

  cockpit = new CockpitResponse()
  cockpitGrafico = new CockpitResponse()
  cockpitPerformance = new CockpitResponse()

  driverPerformance = new MotoristaCollection()

  cockpitPerformancePorData = new CockpitPerformancePorDataResponse()
  cockpitPerformancePorOrigin = new CockpitPerformanceResponse()
  cockpitPerformancePorEmbarcador = new CockpitPerformanceResponse()

  graphType = ChartType.BAR
  driverPerformanceOpen = false

  startMode = true

  beforeCreate() {
    this.redirectIfSac()
  }

  created() {
    if (Helper.getRegraExibicaoGrupoEconomico()) {
      this.populateOnMount = false
    } else {
      this.startMode = false
    }
    this.redirectIfSac()
  }

  async mounted() {
    if (Helper.getRegraExibicaoGrupoEconomico()) {
      this.$await.done('getCockpit')
      this.$await.done('getCockpitPerformance')
      this.$await.done('getCockpitGrafico')
    }
  }

  redirectIfSac() {
      if (Helper.isLogged()) {
          if (Helper.isSac()) {
              this.$router.replace('/reports/delivery/sac')
          }
      }
  }

  get blockDate() {
    return Boolean(this.cockpitGrafico.performanceState !== PerformanceState.HIDDEN)
  }

  get queryDefault() {
    const {
      documentResponsavel,
      documentDestinatario,
      uf,
      region,
      sigla,
      cidade,
      idCentroDeCusto,
      idTipoOcorrencia,
    } = this.filter

    let query = ''

    if (documentResponsavel) query += `&cnpjEmbarcadorTransportador=${documentResponsavel}`
    if (documentDestinatario) query += `&cnpj=${documentDestinatario}`
    if (uf) query += `&uf=${uf}`
    if (region) query += `&region=${region}`
    if (sigla) query += `&sigla=${sigla}`
    if (cidade) query += `&cidade=${cidade}`
    if (idCentroDeCusto) query += `&idCentroDeCusto=${idCentroDeCusto}`
    if (idTipoOcorrencia) query += `&idTipoOcorrencia=${idTipoOcorrencia}`

    return query
  }

  get filterStartDate() {
    if (this.filter.period === Period.HOURLY) {
      return moment(this.filter.date).startOf('day').format()
    } else if (this.filter.period === Period.DAILY) {
      return moment(this.filter.date).startOf('month').format()
    } else if (this.filter.period === Period.MONTHLY) {
      return moment(this.filter.date).startOf('year').format()
    } else {
      return null
    }
  }

  get filterEndDate() {
    if (this.filter.period === Period.HOURLY) {
      return moment(this.filter.date).startOf('day').add(1, 'day').format()
    } else if (this.filter.period === Period.DAILY) {
      return moment(this.filter.date).startOf('month').add(1, 'month').startOf('day').format()
    } else if (this.filter.period === Period.MONTHLY) {
      return moment(this.filter.date).startOf('year').add(1, 'year').startOf('day').format()
    } else {
      return null
    }
  }

  async populate() {
    const firstPromise: Array<Promise<any>> = [
      this.getCockpit(),
      this.getCockpitGrafico(),
    ]

    // Se a performance do  motorista estiver aberta, faço o loading e também a altero quando o filtro for mudado
    if (this.driverPerformanceOpen) {
        firstPromise.concat(this.getPerformance())
    }
    await Promise.all(firstPromise)

    if (this.filter.updateAutomatically === true) {
      this.onUpdate(() => {
        this.getCockpit()
        this.getCockpitGrafico()
        this.getCockpitPerformance()
        this.getPerformance()
        this.getCockpitPerformancePorData()
        this.getCockpitPerformancePorOrigin()
        this.getCockpitPerformancePorEmbarcador()
      })
    } else {
      this.onUpdate(() => {/**/
      })
    }

    // wait the animation over
    await Helper.sleep(500)

    await this.getCockpitPerformance()
  }

  async getCockpit() {
    await this.cockpit.getCockpit(this.filter as CockpitRequest)
    // You should re-authenticate the current account
    // in order to save the 'Permitir notificações' option into the logged responsavel
    await this.auth()
  }

  async getCockpitPerformance() {
    await this.cockpitPerformance.getCockpitPerformance(this.filter as CockpitRequest)
  }

  async getPerformance() {
    await this.driverPerformance.getPerformance(this.filter)
    if (this.user.permitirRastreamentoDistancia && this.driverPerformance.items.length) {
          for (const motorista of this.driverPerformance.items) {
              if (motorista.qtdEmAndamento) {

                  const posicao = new PosicaoMotorista()
                  posicao.idPosicaoPk = motorista.idUltimaPosicaoFk as number
                  const { data } = await posicao.updateDistanceTo()

                  if (data) {
                      motorista.ultimaDistanciaParaDestinoEmMetros = data.distanciaParaDestinoEmMetros
                      motorista.ultimaDuracaoParaDestinoEmSegundos = data.duracaoParaDestinoEmSegundos
                  }

              }
          }
      }
  }

  async getCockpitGrafico() {
    await this.cockpitGrafico.getCockpitGrafico(this.filter as CockpitRequest)
  }

  async getCockpitPerformancePorData() {
    await this.cockpitPerformancePorData.getCockpitPerformancePorData(this.filter as CockpitRequest)
  }

  async getCockpitPerformancePorOrigin() {
    await this.cockpitPerformancePorOrigin.getCockpitPerformancePorOrigem(this.filter as CockpitRequest)
  }

  async getCockpitPerformancePorEmbarcador() {
    await this.cockpitPerformancePorEmbarcador.getCockpitPerformancePorEmbarcador(this.filter as CockpitRequest)
  }

  openChartType(chartType: ChartType) {
    this.cockpitGrafico.performanceState = PerformanceState.HIDDEN
    this.driverPerformanceOpen = false
    this.graphType = chartType

    if (Helper.getRegraExibicaoGrupoEconomico() && this.startMode) {
      this.startMode = false
      this.getCockpit()
      this.getCockpitGrafico()
    }
  }

  async openDriverPerformance() {
    this.cockpitGrafico.performanceState = PerformanceState.HIDDEN
    this.driverPerformanceOpen = true
    this.startMode = false
    this.getPerformance()
  }

  async openPerformanceData() {
    this.cockpitGrafico.performanceState = PerformanceState.DATA
    this.driverPerformanceOpen = false
    this.startMode = false
    await this.applyTodayFilter()
    this.getCockpitPerformancePorData()
  }

  async openPerformanceOrigem() {
    this.cockpitGrafico.performanceState = PerformanceState.ORIGEM
    this.driverPerformanceOpen = false
    this.startMode = false
    await this.applyTodayFilter()
    this.getCockpitPerformancePorOrigin()
  }

  async openPerformanceEmbarcador() {
    this.cockpitGrafico.performanceState = PerformanceState.EMBARCADOR
    this.driverPerformanceOpen = false
    this.startMode = false
    await this.applyTodayFilter()
    this.getCockpitPerformancePorEmbarcador()
  }

  async openIFrame() {
    this.cockpitGrafico.performanceState = PerformanceState.BI
    this.driverPerformanceOpen = false
    this.startMode = false
  }

  async applyTodayFilter() {
    this.filter.date = moment().format()
    this.filter.period = Period.HOURLY
    await this.filtrate()
  }

  chartTypeIsOpen(chartType: ChartType) {
    return !this.driverPerformanceOpen && !this.cockpitGrafico.performanceState && this.graphType === chartType
  }

  beforeDestroy() {
    this.onUpdate(() => {/**/
    })
  }

  @Watch('filter.allowNotification')
  async persistAllowNotification() {
    await this.cockpit.getCockpit(this.filter as CockpitRequest)
    await this.auth
    success('system.success.persist')
  }

  onFilter() {
    this.startMode = false
    this.filtrate()
  }

  get forcarQuery() {
    if (Helper.getRegraExibicaoGrupoEconomico()) {
      return 'forcar=true&'
    }
    return ''
  }
}
